import { useQuery } from "@tanstack/react-query";
import api from "../../../utils/api/axiosInstance";

/**
 * React Query hook for fetching all badge counts in one lightweight call
 * Used by profile navigation to show counts without loading full datasets
 * @param {string} userId - User ID
 * @param {boolean} enabled - Whether the query should run
 */
export const useBadgeCountsQuery = (userId, enabled = true) => {
  return useQuery({
    queryKey: ["badgeCounts", userId],
    queryFn: async () => {
      const res = await api.get("/users/me/badge-counts");
      return res.data;
    },
    enabled: enabled && !!userId,
    refetchInterval: 60000, // Refetch every minute to keep counts fresh
    staleTime: 30000, // Consider data stale after 30 seconds
  });
};
